import { PushModule } from '@rx-angular/template/push';
import { LetModule } from '@rx-angular/template/let';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '@app/material';

import { PlayerModule } from '@app/player';

import { MainNavComponent } from './main-nav/main-nav.component';
import { CardComponent } from './card/card.component';
import { ThumbnailComponent } from './thumbnail/thumbnail.component';
import { ArticleComponent } from './article/article.component';
import { ScreenComponent } from './screen/screen.component';
import { IconComponent } from './icon/icon.component';
import { ChipsComponent } from './chips/chips.component';
import { FacetsComponent } from './facets/facets.component';
import { PageNavComponent } from './page-nav/page-nav.component';
import { FooterComponent } from './footer/footer.component';
import { JoinCommunityComponent } from './join-community/join-community.component';
import { GridComponent } from './grid/grid.component';
import { MoreBtnComponent } from './more-btn/more-btn.component';
import { PagerComponent } from './pager/pager.component';
import { LoaderComponent } from './loader/loader.component';
import { SortComponent } from './sort/sort.component';
import { SchoolCardComponent } from './school-card/school-card.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { CardBigComponent } from './card-big/card-big.component';
import { CardLogoComponent } from './card-logo/card-logo.component';
import { FacetComponent } from './facet/facet.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { InputComponent } from './input/input.component';
import { SearchContentComponent } from './search-content/search-content.component';
import { TabsComponent } from './tabs/tabs.component';
import { ChipComponent } from './chip/chip.component';
import { RecommandedComponent } from './recommanded/recommanded.component';
import { RouteLinkComponent } from './route-link/route-link.component';
import { ScrollIntoViewComponent } from './scroll-into-view/scroll-into-view.component';
import { PageBottomComponent } from './page-bottom/page-bottom.component';
//import { ScrollDirective } from './scroll/scroll.directive';
import { BackBtnComponent } from './back-btn/back-btn.component';
import { IsInViewComponent } from './is-in-view/is-in-view.component';
import { MobileNavComponent } from './mobile-nav/mobile-nav.component';
import { LogoComponent } from './logo/logo.component';
import { FiltersComponent } from './filters/filters.component';
import { MediaComponent } from './media/media.component';
import { DataComponent } from './data/data.component';
import { IconCloseComponent } from './icon-close/icon-close.component';
import { SubpageNavigationComponent } from './subpage-navigation/subpage-navigation.component';
import { VideoCardComponent } from './video-card/video-card.component';
import { UserBadgeComponent } from './user-badge/user-badge.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    //FormsModule,
    //ReactiveFormsModule,
    RouterModule,
    PlayerModule,
    MaterialModule,
    LetModule,
    PushModule,
  ],
  declarations: [
    MainNavComponent,
    CardComponent,
    ThumbnailComponent,
    ArticleComponent,
    ScreenComponent,
    IconComponent,
    ChipsComponent,
    FacetsComponent,
    PageNavComponent,
    FooterComponent,
    JoinCommunityComponent,
    GridComponent,
    MoreBtnComponent,
    PagerComponent,
    LoaderComponent,
    SortComponent,
    SchoolCardComponent,
    PageHeaderComponent,
    CardBigComponent,
    CardLogoComponent,
    FacetComponent,
    SearchBarComponent,
    InputComponent,
    SearchContentComponent,
    TabsComponent,
    ChipComponent,
    RecommandedComponent,
    RouteLinkComponent,
    ScrollIntoViewComponent,
    PageBottomComponent,
    BackBtnComponent,
    IsInViewComponent,
    MobileNavComponent,
    LogoComponent,
    FiltersComponent,
    MediaComponent,
    DataComponent,
    IconCloseComponent,
    SubpageNavigationComponent,
    VideoCardComponent,
    UserBadgeComponent,
  ],
  exports: [
    MainNavComponent,
    CardComponent,
    ThumbnailComponent,
    ArticleComponent,
    ScreenComponent,
    IconComponent,
    ChipsComponent,
    FacetsComponent,
    PageNavComponent,
    FooterComponent,
    JoinCommunityComponent,
    GridComponent,
    MoreBtnComponent,
    PagerComponent,
    LoaderComponent,
    SortComponent,
    SchoolCardComponent,
    PageHeaderComponent,
    CardBigComponent,
    CardLogoComponent,
    FacetComponent,
    SearchBarComponent,
    InputComponent,
    SearchContentComponent,
    TabsComponent,
    ChipComponent,
    RecommandedComponent,
    RouteLinkComponent,
    ScrollIntoViewComponent,
    PageBottomComponent,
    BackBtnComponent,
    IsInViewComponent,
    MobileNavComponent,
    LogoComponent,
    FiltersComponent,
    MediaComponent,
    DataComponent,
    IconCloseComponent,
    SubpageNavigationComponent,
    VideoCardComponent,
    UserBadgeComponent,
  ],
})
export class UiModule {}
